// Métadonnées du site, partagées entre gatsby-config.js et les composants.
// Module séparé : importer gatsby-config.js depuis src/ embarquerait toute la config
// (et ses dépendances Node, ex. fs) dans les bundles webpack.
module.exports = {
  siteMetadata: {
    // If you didn't use the resolveSiteUrl option this needs to be set
    siteUrl: `https://tallerdeltotebag.es`,
  },
};
